wo'c
<template>
  <div class="productionReport">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">生产报表</div>
        <div class="select-container">
          <div class="select-container-box tab">
            <el-select v-model="memoryValue" size="small" placeholder="请选择" @change="changeBatDateList">
              <el-option v-for="item in batDateList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="memoryValue == 'date'">
            <!-- <span>日期</span> -->
            <el-date-picker size="small" :clearable="false" v-model="order.startDate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" @change="changeTime(0)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
            <span>至</span>
            <el-date-picker size="small" :clearable="false" v-model="order.endDate" type="date" placeholder="结束日期" @change="changeTime(1)" value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" v-if="memoryValue == 'Batch'">
            <!-- <span>周期&nbsp;&nbsp;</span> -->
            <el-select v-model="batch" size="small" placeholder="请选择" @change="batchChange">
              <el-option v-for="item in batchList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>基地</span>
            <el-select filterable placeholder="请选择" size="small" v-model="order.baseId" @change="baseChange">
              <el-option v-for="(item, index) in baseList" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>塘口</span>
            <el-select filterable placeholder="请选择" @change="pondChange" size="small" v-model="order.pondId">
              <el-option v-for="(item, index) in pondList" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>品种</span>
            <el-select filterable placeholder="请选择" size="small" v-model="order.fishId" style="">
              <el-option v-for="(item, index) in fishList" :key="index" :label="item.categoryName" :value="item.categoryId">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box total">
            <span>汇总方式</span>
            <el-select v-model="groupBy" multiple size="middle" placeholder="请选择" @change="setCache">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small" type="info" plain class="query" @click="search(1)">查询</el-button>
            <!-- <el-button size="small"  type="info" plain  class="add" >导出</el-button> -->
          </div>
          <ExportExcelBtn apiUrl="/api/ProductionReport/ExportProductionReport" :queryParamsObj="searchQueryParams" fileName="生产报表.xls" />
        </div>
      </div>
      <div class="table-container">
        <!-- 1 -->
        <table class="table-package" :class="isTop ? 'fix' : ''">
          <thead class="table-thead">
            <tr>
              <th rowspan="2" class="ths" v-if="showCol(4)">负责人</th>
              <th rowspan="2" class="ths" v-if="showCol(2)">塘口</th>
              <th rowspan="2" class="ths" v-if="showCol(2)">面积(亩)</th>
              <th rowspan="2" class="ths" v-if="showCol(1)">品种</th>
              <th colspan="5" class="thss">苗种投放</th>
              <th colspan="3" class="thsss">饲料使用</th>
              <th colspan="1" class="thsss">损失</th>
              <th colspan="5" class="thss">成鱼出塘</th>
            </tr>
            <tr class="trs">
              <th>规格</th>
              <th>尾数</th>
              <th>重量（斤）</th>
              <th>单价</th>
              <th>金额(元)</th>
              <th>用量(斤)</th>
              <th>饵料系数</th>
              <th>金额(元)</th>
              <th>尾数</th>
              <th>尾数</th>
              <th>重量（斤）</th>
              <th>规格</th>
              <th>单价</th>
              <th>金额(元)</th>
            </tr>
          </thead>
        </table>
        <!-- 2 -->
        <div class="scroll-box1" ref="scrollBox">
          <table class="table-package">
            <tbody class="table-tbodys" v-if="this.order.details.length !== 0">
              <tr v-for="(item, index) in order.details" :key="index">
                <td v-if="showCol(4)" :rowspan="item.leaderIdspan" :class="{ hidden: item.leaderIddis }">
                  {{ item.leaderName }}
                </td>
                <td v-if="showCol(2)" :rowspan="item.pondIdspan" :class="{ hidden: item.pondIddis }">
                  {{ item.pondName }}
                </td>
                <td v-if="showCol(2)" :rowspan="item.pondAreaspan" :class="{ hidden: item.pondAreadis }">
                  {{ item.pondArea | decimal }}
                </td>
                <td v-if="showCol(1)">{{ item.fishName }}</td>
                <td>{{ item.purchaseSpec | decimal }}</td>
                <td>{{ item.purchaseQuantity | decimal }}</td>
                <td>{{ item.purchaseWeight | decimal }}</td>
                <td>{{ item.purchasePrice | decimal }}</td>
                <td>{{ item.purchaseAmount | decimal }}</td>
                <td>{{ item.fodderWeight | decimal }}</td>
                <td>{{ item.feedCoefficient | decimal }}</td>
                <td>{{ item.fodderAmount | decimal }}</td>
                <td>{{ item.loss | decimal }}</td>
                <td>{{ item.saleQuantity | decimal }}</td>
                <td>{{ item.saleWeight | decimal }}</td>
                <td>{{ item.saleSpec | decimal }}</td>
                <td>{{ item.salePrice | decimal }}</td>
                <td>{{ item.saleAmount | decimal }}</td>
              </tr>
            </tbody>
            <tbody class="table-tbodys" v-if="this.order.details.length === 0">
              <tr>
                <td colspan="17">该时间段暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 3 -->
        <table class="table-package">
          <tfoot class="table-tfoot" v-if="this.order.details.length !== 0">
            <tr class="row">
              <td v-if="showCol(4)">合计</td>
              <td v-if="showCol(2)">{{ !showCol(4) ? "合计" : "--" }}</td>
              <td v-if="showCol(2)">{{ totalArea().toFixed(2) }}</td>
              <td v-if="showCol(1)">
                {{ !showCol(2) && !showCol(4) ? "合计" : "--" }}
              </td>
              <td>
                {{
                  (total("purchaseSpec") / this.order.details.length) | decimal
                }}
              </td>
              <td>{{ total("purchaseQuantity") | decimal }}</td>
              <td>{{ total("purchaseWeight") | decimal }}</td>
              <td>
                {{
                  (total("purchasePrice") / this.order.details.length) | decimal
                }}
              </td>
              <td>{{ total("purchaseAmount") | decimal }}</td>
              <td>{{ total("fodderWeight") | decimal }}</td>
              <td>
                {{
                  (total("saleWeight") + total('storageWeight') - total("purchaseWeight")) > 0
                    ? total("fodderWeight") /
                      (total("saleWeight") + total('storageWeight') - total("purchaseWeight"))
                    : 0 | decimal
                }}
              </td>
              <td>{{ total("fodderAmount") | decimal }}</td>
              <td>{{ total("loss") | decimal }}</td>
              <td>{{ total("saleQuantity") | decimal }}</td>
              <td>{{ total("saleWeight") | decimal }}</td>
              <td>
                {{ (total("saleSpec") / this.order.details.length) | decimal }}
              </td>
              <td>
                {{ (total("salePrice") / this.order.details.length) | decimal }}
              </td>
              <td>{{ total("saleAmount") | decimal }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../service/storage";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import ExportExcelBtn from "../common/ExportExcelBtn";
import {
  resolveFishBaseKeyFromList,
  fishBaseIdForQuery,
} from "@/common/resolveFishBaseSelection.js";
export default {
  mixins: [mixins],
  name: "productionReport",
  components: { ExportExcelBtn },
  data () {
    return {
      memoryValue: "date",
      batDateList: [
        {
          value: "Batch",
          label: "周期",
        },
        {
          value: "date",
          label: "时间",
        },
      ],
      batch: "",
      batchList: [],
      options: [
        {
          value: "1",
          label: "品种",
        },
        {
          value: "2",
          label: "塘口",
        },
        {
          value: "4",
          label: "负责人",
        },
      ],
      // 限制日期
      pickerTimeOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      order: {
        groupBy: 7, //汇总方式-默认全选
        baseId: "", //基地
        pondId: "", //塘口
        startDate: "", //开始时间
        endDate: "", //结束时间
        remark: "",
        details: [],
        fishId: "",
      },
      groupBy: ["1", "2"],
      baseList: [],
      pondList: [],
      fishList: [],
      isTop: false,
      fixWidth: 0,
    };
  },
  async mounted () {
    // 监听滚动
    window.addEventListener("scroll", this.getScroll, true);
    // 设置表头宽度
    this.fixWidth = this.$refs.scrollBox.offsetWidth - 5;
    window.onresize = () => {
      return (() => {
        this.fixWidth = this.$refs.scrollBox.offsetWidth;
      })();
    };
    this.baseList = await this.getAllBaseList(); //基地
    this.order.baseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    if (this.order.baseId != null) {
      await this.baseChange(this.order.baseId);
    }

    this.judgeChoose();
    this.getBatch();
    this.getCache();
    this.search();
  },
  methods: {
    //监听滚动
    getScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 180) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.report, {
      GetProductionReport: "GetProductionReport",
    }),
    ...mapActions(modules.fish, {
      getFishReport: "getFishReport", //品种
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond", //塘口
    }),
    ...mapActions(modules.cultureCycle, {
      getBatchList: "getBatchList", //周期下拉
    }),

    //动态合并表格
    combine (list, field, assistFields = []) {
      var k = 0;
      while (k < list.length) {
        list[k][field + "span"] = 1;
        list[k][field + "dis"] = false;
        for (var i = k + 1; i <= list.length - 1; i++) {
          let isEqual =
            list[k][field] == list[i][field] && list[k][field] != "";

          assistFields.forEach((item) => {
            isEqual =
              isEqual && list[k][item] == list[i][item] && list[k][item] != "";
          });

          if (isEqual) {
            list[k][field + "span"]++;
            list[k][field + "dis"] = false;
            list[i][field + "span"] = 1;
            list[i][field + "dis"] = true;
          } else {
            break;
          }
        }
        k = i;
      }
      return list;
    },

    //汇总方式必须选一个
    showCol (value) {
      return (this.order.groupBy & value) > 0;
    },
    //总计
    total (prop) {
      let total = 0;
      this.order.details.forEach((item) => (total += Number(item[prop])));
      return total;
    },

    //面积总计
    totalArea () {
      let map = new Map();
      this.order.details.forEach((item) =>
        map.set(`${item.pondArea}${item.pondId}`, item.pondArea)
      );
      return [...map.values()].reduce((pre, cur) => pre + cur);
    },
    //改变基地数据
    async baseChange (e) {
      storage.set("base", e);
      this.pondList = [];
      if (!e) return;
      let result = await this.getFishPond(e);
      this.pondList = [
        {
          key: "",
          value: "全部",
        },
      ].concat(result);
      if (this.pondList.length === 0) {
        this.$Alert.info({
          content: "当前选择的基地下面无塘口，请先添加",
          duration: 5000,
          status: "error",
        });
        // Message.error("当前选择的基地下面无塘口，请先添加");
      }
      this.order.pondId = "";
      this.getFish();
      this.order.fishId = "";
    },
    //改变塘口数据
    async pondChange (e) {
      this.getFish();
      this.order.fishId = "";
    },
    //品种
    getFish () {
      let obj = {
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
        pondId: this.order.pondId,
      };
      this.getFishReport(obj).then((rsp) => {
        this.fishList = [
          {
            categoryId: "",
            categoryName: "全部",
          },
        ].concat(rsp);
      });
    },
    //存储选中时间
    changeTime (type) {
      if (type == 0) {
        storage.set("start", this.order.startDate);
      } else {
        storage.set("end", this.order.endDate);
      }
    },
    // 获取周期下拉
    async getBatch () {
      this.batchList = await this.getBatchList();
      this.batchList.unshift("全部");
      // this.batchList = this.batchList;
      this.batch = "全部";
    },
    // 判断localstorage 是周期还是时间
    judgeChoose () {
      let memoryValue = localStorage.getItem("memoryValue");
      if (memoryValue) {
        this.memoryValue = memoryValue;
      } else {
        this.memoryValue = this.memoryValue;
      }
      if (this.memoryValue == "Batch") {
        // this.start = "";
        // this.end = "";
        this.batch = "全部";
      } else if (this.memoryValue == "date") {
        this.batch = "";
      }
    },
    //切换时间和周期
    changeBatDateList (e) {
      localStorage.setItem("memoryValue", e);
      console.log(e);
      if (e == "Batch") {
        // this.start = "";
        // this.end = "";
        this.batch = "全部";
      } else if (e == "date") {
        this.batch = "";
      }
    },
    //周期切换
    batchChange (e) {
      if (e) {
        this.batch = e;
        //this.getAllData();
      }
    },
    //查询
    async search () {
      let obj = this.searchQueryParams;

      try {
        this.order.details = this.combine(
          await this.GetProductionReport(obj),
          "pondId"
        );

        this.order.details = this.combine(this.order.details, "pondArea", [
          "pondId",
        ]);

        this.order.details = this.combine(this.order.details, "leaderId");

        this.order.groupBy = obj.groupBy;
      } catch (e) {
        Message.error(e.response.data);
        console.log(e);
      }
    },
    setCache () {
      localStorage.setItem(
        "productionReportGroupBy",
        JSON.stringify(this.groupBy)
      );
    },
    getCache () {
      const groupBy = localStorage.getItem("productionReportGroupBy");
      if (
        groupBy &&
        groupBy.length > 1 &&
        groupBy.indexOf("1") > -1 &&
        groupBy.indexOf("2") > -1
      ) {
        this.groupBy = JSON.parse(groupBy);
      }
    },
  },
  //默认时间
  created () {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.order.startDate = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      start.setMonth(0);
      this.order.startDate = this.$timeformatDay(start);
    }
    if (endTime) {
      this.order.endDate = endTime;
    } else {
      this.order.endDate = this.$timeformatDay(new Date());
    }
  },
  watch: {
    groupBy: function (val, oldVal) {
      if (val.length < 1) {
        this.$message({
          message: "必须选中一项",
          type: "warning",
        });
        this.groupBy = oldVal;
      }
      if (val.indexOf("1") < 0) {
        this.$message({
          message: "品种必须选中",
          type: "warning",
        });
        this.groupBy = oldVal;
      }
      if (val.indexOf("2") < 0) {
        this.$message({
          message: "塘口必须选中",
          type: "warning",
        });
        this.groupBy = oldVal;
      }
    },
  },

  computed: {
    searchQueryParams () {
      let queryParams = {
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
        batch:
          this.batch !== "全部" && this.memoryValue == "Batch"
            ? this.batch
            : "",
        startDate: this.memoryValue == "date" ? this.order.startDate : "",
        endDate: this.memoryValue == "date" ? this.order.endDate : "",
        fishId: this.order.fishId,
        pondId: this.order.pondId,
        groupBy: this.groupBy.reduce((now, next) => Number(now) + Number(next)),
      };
      return queryParams;
    },
  },
};
</script>
<style lang="stylus">
.productionReport {
  .total {
    .el-select__tags {
      top: 65%;
      height: 30px;
      overflow: auto;
    }

    .el-input__suffix {
      top: 6px;
    }

    .is-focus .el-input__suffix {
      top: 0px;
    }
  }

  .scroll-box1 {
    width: 100%;
    // overflow: auto;
    // overflow-x:hidden;
  }

  .table-package {
    width: 100%;
    border-collapse: collapse;
    border: none;
  }

  .table-thead {
    border-top: 2px solid rgb(51, 137, 255);

    .ths, .thsss {
      width: 50px !important;
    }

    >tr th {
      text-align: center;
      height: 36px;
      font-size: 12px;
      line-height: 36px;
      color: #666;
      font-weight: bold;
      border: 1px solid #e0e0e0;
      border-bottom: none;
      background-color: #f7f7f7;
    }

    >tr .ths {
      display: table-cell;
      border-bottom: 1px solid rgb(51, 137, 255);
      vertical-align: middle;
    }

    >tr .thss {
      border-bottom: 1px solid rgb(51, 137, 255);
    }

    .trs th {
      width: 50px !important;
      border-bottom: 1px solid rgb(51, 137, 255);
    }
  }

  .table-tbodys {
    :hover {
      background: #c3e3ff;

      td:nth-child(1), td:nth-child(2), td:nth-child(3) {
        background: #fff;
      }
    }

    tr {
      text-align: center;
      height: 37px;
      line-height: 37px;
      border: 1px solid #ddd;
      border: none;
      background-color: #fff;
      font-size: 12px;
    }

    td {
      width: 50px !important;
      border: 1px solid #e0e0e0;
      border-top: none;
      color: #666;
      max-width: 96px;
      word-break: break-all;
      vertical-align: middle;
    }
  }

  .table-tfoot {
    tr>td {
      text-align: center;
      height: 37px;
      line-height: 37px;
      color: #333;
      font-size: 12px;
      width: 90px !important;
      font-weight: bold;
      border: 1px solid #e0e0e0;
      border-top: none;
    }

    .row {
      // font-size: 12px;
      // background-color: #fff;
      // font-weight: bold;
      >td {
        // width:50px!important;
        // text-align: center;
        // border: 1px solid #e0e0e0;
        // color: #666;
        // font-weight:bold;
      }
    }
  }

  .hidden {
    display: none;
  }
}

.productionReport .table-package.fix {
  color: #666;
  position: fixed;
  z-index: 1000;
  top: 0px;
  width: calc(100% - 250px);
}
</style>
